import React, { Component } from 'react';
import { Container, Modal } from 'semantic-ui-react';
import styled from 'styled-components';
import { getProposalGroup, getProposalStore, approveStores } from 'services/proposalService';
import { ProposalMap } from 'components';
import toastr from 'helpers/toastr';
import channelTalkService from 'helpers/channeltalk';
import successIcon from 'images/mapClustoer/success_Icon.svg';
import img from 'images/mapClustoer/sikdae_log.svg';

const Wrapper = styled.div`
  height: 100%;
`;

const Display = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

const StyledContainer = styled(Container)`
  &&& {
    max-width: 1600px;
    // height: calc(100vh - 150px);
    height: 100vh;
    margin: auto;
    display: flex;
    flex-direction: row;
    @media only screen and (max-width: 768px) {
      flex-direction: column;
      height: auto;
      margin: 0 !important;
    }
  }
`;

const Modals = styled(Modal)`
  height: 446px !important;
  width: 485px !important;

  @media only screen and (max-width: 768px) {
    width: 100% !important;
    height: 95% !important;
  }
`;

const Contents = styled(Modal.Content)`
  text-align: center;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;

  & .title {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 36px;
    color: #212529;
    padding-bottom: 24px;
  }

  & .paddingTop {
    padding-top: 24px;
  }

  & img {
    padding-bottom: 16px;
  }
`;

const Box = styled(Modal.Content)`
  position: relative;
  width: 343px;
  //height: 68px;
  padding: 24px 8px;
  background: #f8f8f8;
  border-radius: 8px;
  margin: auto;

  & p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #212529;
    //position: absolute;
    //top: 50%;
    //left: 50%;
    //transform: translate(-50%, -50%);
    width: 100%;
  }
`;

const ModalButton = styled.button`
  width: 164px;
  height: 48px;
  left: calc(50% - 164px / 2 - 89.5px);
  top: calc(50% - 48px / 2);
  background: #ffffff;
  border: 1px solid #ededf2;
  box-sizing: border-box;
  border-radius: 8px;
  cursor: pointer;
`;

const intersection = (a, b) => a.filter((e) => b.includes(e));
const not = (a, b) => a.filter((e) => !b.includes(e));
// eslint-disable-next-line no-unused-vars
const numberOfChecked = (items, a) => intersection(items, a).length;
const union = (a, b) => [...b, ...not(a, b)];

class ProposalStoreMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      planOfficeStoreRelationIdx: null,
      availableCount: 0,
      status: '',
      selectedAddress: '',
      address: [],
      stores: [],
      selectedStores: {},
      open: false,
      show: false,
      type: 'PC',
      success: false,
      map: {
        idx: null,
        office: {},
        stores: []
      },
      markers: []
    };
  }

  async componentDidMount() {
    await this.getPlanGroup();
    // eslint-disable-next-line no-undef
    $('#root>div').css('min-width', 'auto');
    channelTalkService.shutdown();
  }

  setMarker = (markers) => {
    this.setState({ markers });
  };

  getPlanGroup = async () => {
    const { match: { params: { id } = {} } = {} } = this.props;
    if (!id) return;
    try {
      const { planGroup: { status } = {}, plans = [] } = await getProposalGroup(id);
      const address = plans.map(({ planIdx: v, address: t }) => ({ key: v, value: v, text: t }));
      this.setState({
        planGroupIdx: id,
        status,
        address,
        selectedAddress: address && address[0] ? address[0].value : ''
      });
      if (address && address[0]) {
        await this.getPlanStores(address[0].value);
      }
    } catch (e) {
      const { response: { data } = {} } = e || {};
      if (data) {
        const { status, message } = data;
        toastr('top-right', 'error', message);
        if (status === -9901) {
          this.setState({ status: 'APPROVAL' });
        }
      }
    }
  };

  getPlanStores = async (idx) => {
    if (!idx) return;
    const { match: { params: { id: groupIdx } = {} } = {} } = this.props;
    try {
      const { planStores, plan: { planIdx, gpsLat, gpsLon, availableCount, status } = {} } = await getProposalStore(
        groupIdx,
        idx
      );
      this.setState({
        stores: planStores,
        availableCount,
        status,
        planOfficeStoreRelationIdx: planIdx,
        map: {
          idx: planIdx,
          office: {
            gpsLat,
            gpsLon
          },
          stores: planStores
        }
      });
      if (status === 'APPROVAL') {
        toastr('top-right', 'info', '제출 완료된 주소지입니다.');
      }
    } catch (e) {
      const { response: { data } = {} } = e || {};
      if (data) {
        const { message } = data;
        toastr('top-right', 'error', message);
        // if (status === -9901) {
        //   this.setState({ status: 'APPROVAL' });
        // }
      }
    }
  };

  selectAddress = async (e, { value: idx }) => {
    this.setState({
      selectedAddress: idx
    });
    await this.getPlanStores(idx);
  };

  selectedComplete = async () => {
    // eslint-disable-next-line no-restricted-globals,no-alert
    // if (!confirm('선택 완료 후 수정은 담당자에게 문의 하시기 바랍니다. 선택 완료 하시겠습니까?')) {
    //   return;
    // }

    this.setState({ open: true });
  };

  handleChangeAll = (_, { checked }) => {
    const { stores, selectedStores, planOfficeStoreRelationIdx } = this.state;
    let selected = [];
    if (checked) {
      selected = stores.map((e) => e.sid);
    }
    this.setState({
      selectedStores: {
        ...selectedStores,
        [planOfficeStoreRelationIdx]: selected
      }
    });
  };

  handleChange = (index, checked, value) => {
    const { selectedStores, availableCount, planOfficeStoreRelationIdx } = this.state;
    const selected = selectedStores[planOfficeStoreRelationIdx] || [];
    const selectedCount = selected.filter((e) => e.isSelected).length;
    if (checked && selectedCount >= availableCount) {
      toastr('top-right', 'warning', '최대 선택 가능한 식당만큼 선택 할 수 있습니다.');
      return;
    }
    // const { planOfficeStoreRelationIdx } = this.props;
    // const draftSelectedStore = selectedStores[planOfficeStoreRelationIdx];
    // this.setState({
    //   stores: update(stores, {
    //     [index]: {
    //       isSelected: { $set: value }
    //     }
    //   })
    // });

    this.setState((prevState) => {
      const { selectedStores: prevSelectedStore } = prevState;
      let draftSelectedStore = prevSelectedStore[planOfficeStoreRelationIdx] || [];
      // const sid = value ? [stores[index].sid] : [];
      if (!checked) {
        draftSelectedStore = not(draftSelectedStore, [value]);
      } else {
        draftSelectedStore = union(draftSelectedStore, [value]);
      }
      return {
        ...prevState,
        // stores: update(prevStores, {
        //   [index]: {
        //     isSelected: { $set: value }
        //   }
        // }),
        selectedStores: {
          ...prevSelectedStore,
          [planOfficeStoreRelationIdx]: draftSelectedStore
        }
      };
    });
  };

  handleConfirm = async () => {
    const { planGroupIdx, selectedStores } = this.state;

    const approval = Object.entries(selectedStores).map(([k, v]) => ({ planOfficeStoreRelationIdx: k, storeIds: v }));

    try {
      const { status } = await approveStores(planGroupIdx, approval);
      this.setState({
        stores: [],
        availableCount: 0,
        status,
        map: {
          idx: null,
          office: {},
          stores: []
        }
      });
      // toastr('top-right', 'success', '저장 되었습니다. 수정은 담당자에게 문의 하시기 바랍니다.');
      this.setState({ success: true });
    } catch (e) {
      const { response: { data } = {} } = e || {};
      if (data) {
        const { message } = data;
        toastr('top-right', 'error', message);
      }
    }
  };

  onClick = (type) => {
    this.setState({ show: true, type });
  };

  onMobileCancel = () => {
    this.setState({ open: false });
  };

  render() {
    const {
      stores,
      map,
      availableCount,
      status,
      markers,
      open,
      address,
      selectedAddress,
      selectedStores,
      planOfficeStoreRelationIdx,
      success
    } = this.state;
    // eslint-disable-next-line no-unused-vars
    const selectedCount = stores.filter((e) => e.isSelected).length;
    const addressMap = address.reduce((a, c) => ({ ...a, [c.value]: c.text }), {});

    return (
      <Wrapper>
        <div style={{ display: window.innerWidth <= 768 && open ? 'none' : 'block' }}>
          <Display>
            <ProposalMap.MapHeader value={selectedAddress} onSelected={this.selectAddress} address={address} />
          </Display>

          <StyledContainer fluid>
            <ProposalMap.Map map={map} setMarker={this.setMarker} />
            <ProposalMap.Stores
              availableCount={availableCount}
              status={status}
              stores={stores}
              markers={markers}
              value={selectedAddress}
              selectedStores={selectedStores[planOfficeStoreRelationIdx]}
              onSelected={this.selectAddress}
              address={address}
              onChangeAll={this.handleChangeAll}
              onChange={this.handleChange}
              onComplete={this.selectedComplete}
            />
          </StyledContainer>
        </div>

        {/* eslint-disable-next-line no-nested-ternary */}
        {window.innerWidth <= 768 ? (
          open ? (
            <ProposalMap.Send
              addressMap={addressMap}
              success={success}
              selectedStores={selectedStores}
              onConfirm={this.handleConfirm}
              onCancel={this.onMobileCancel}
            />
          ) : null
        ) : (
          <Modals
            onClose={() => this.setState({ open: false })}
            onOpen={() => this.setState({ open: true })}
            open={open}
            style={{ height: '446px', width: '485px' }}
          >
            <Contents>
              {success ? (
                <div>
                  <img alt="successIcon" src={successIcon} />
                  <div className="title">제출완료</div>
                  <Box style={{ height: '88px' }}>
                    <p>
                      제휴식당 선택제출이 완료되었습니다.
                      <br />
                      영업담당자가 결과를 확인중입니다.
                    </p>
                  </Box>
                </div>
              ) : (
                <div>
                  <div className="title">정말로 제출하시겠습니까?</div>
                  <Box>
                    {selectedStores &&
                      Object.entries(selectedStores).map(([k, e]) => (
                        <p key={k}>
                          {addressMap[k]}, {e.length}개 선택 완료
                        </p>
                      ))}
                  </Box>
                  <div className="paddingTop">
                    <ModalButton onClick={() => this.setState({ open: false })} style={{ marginRight: '15px' }}>
                      돌아가기
                    </ModalButton>
                    <ModalButton onClick={this.handleConfirm}>완료</ModalButton>
                  </div>
                </div>
              )}
            </Contents>
          </Modals>
        )}
      </Wrapper>
    );
  }
}

export default ProposalStoreMap;
